import { createAction } from "@reduxjs/toolkit";
export const FETCH_ACTIVE_DOMAIN_CALL = 'FETCH_ACTIVE_DOMAIN_CALL';
export const fetchActiveCallAction = createAction(FETCH_ACTIVE_DOMAIN_CALL);